// Stage 1 "Silent defaults" · group G2 (lock / substantive gate) — the screen strings of the group's findings. EN + AR.
// Merged into lib/i18n.js at the end (big-file rule: one import + the two _overrideDeep lines).
export const I18N_SD_G2 = {
  en: {
    b35u: {
      // A-8: the two new lock-blocker kinds of the lock readiness table / lock preflight
      kind: { materiality: "Materiality", scope_check: "Scope check" },
    },
    inv6: {
      // A-6: the final records were never entered / compared ("Mark complete" gate reason)
      reasons: { final_difference_missing: "Enter the final listing, the count results and the TB total; explain any difference." },
    },
    est: {
      // A-7: management bias never evaluated ("Mark complete" gate reason)
      reasons: { bias_not_evaluated: "Evaluate possible management bias: indicators present — Yes or No." },
    },
    errors: {
      // A-31: a vouching item ticked Tested with nothing behind it (the backend's 400, shown by toErrMsg in AR)
      VOUCHING_TESTED_NO_EVIDENCE: "Tested needs evidence: link a document to the item, record an assertion, or bypass the missing document with a remark, then tick Tested.",
    },
  },
  ar: {
    b35u: {
      kind: { materiality: "الأهمية النسبية", scope_check: "فحص النطاق" },
    },
    inv6: {
      reasons: { final_difference_missing: "أدخل الكشف النهائي ونتائج العدّ وإجمالي الميزان؛ واشرح أي فرق." },
    },
    est: {
      reasons: { bias_not_evaluated: "قيّم احتمال تحيّز الإدارة: هل توجد مؤشرات — نعم أو لا." },
    },
    errors: {
      VOUCHING_TESTED_NO_EVIDENCE: "يحتاج \"تم الفحص\" إلى دليل: اربط مستنداً بالبند، أو سجّل تأكيداً، أو تجاوز المستند المفقود مع ملاحظة، ثم علّم \"تم الفحص\".",
    },
  },
};

export default I18N_SD_G2;
